<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center h-100 w-100">
                <img src="../../../assets/images/banners/recognition-bannarimage.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="recognition banner" />
                <img src="../../../assets/images/banners/recognition-mobile.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="recognition mobile banner" />
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section" role="heading" aria-level="1">
                            <div class="align-items-center banner-content-title  global_title global_banner_title">
                                <span>Recognition & Reviews</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                <span>From our esteemed clients and employees. </span>
                            </div>
                            <div class="col pt-lg-5 pt-3 mt-lg-3">
                                <a href="/careers" role="button"  tabindex="0" aria-label="View Careers Page" class="global_button  text-left col  text-white white_button" >
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="View Careers to join our team" /></div>
                                    JOIN OUR TEAM
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--============ Banner End ============-->
<section>
    <div class="awards">
        <div class="container">
            <div class="cybersecurity-about-box">
                <div class="row">
                    <div class="application_content_service global_section_header col-12 py-4 text-center">
                        Awards and Recognition
                    </div>
                </div>
                <div class="row awards-and-recognition">
                    <div class="col-lg-4 text-center">
                        <div class="managed-it ">
                            <img src="../../../assets/images/recognition/sushma-mam-image (1).png" height="50%"
                                width="50%" alt="CTO">
                        </div>
                    </div>
                    <div class="col-lg-7 offset-lg-1">
                        <div class="global_section_content testimonial-slider__text awards-content">
                            Over 24 years experience as a demonstrated leader, and in-depth technology expertise -
                            Sushma strives to sustain a culture of diversity and inclusion. Has a proven track record to
                            deliver intelligent, innovative, cost-effective &amp; secure infrastructure applications to
                            global businesses.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--============ What our Clients Say Start ============-->
<section class="recogniton-carosel bg-light pt-5 pb-5">
    <div class="testimonial-slider-area mb-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-wrap text-center section-space--mb_40">
                        <div class="section-sub-title mb-20 sixthheading" role="heading" aria-level="1">Hear From Happy Customers</div>
                        <p>Here are a few testimonials from some of the people we serve throughout the world. </p>
                    </div>
                    <div class="testimonial-slider mt-5">
                        <swiper-container #swiperContainer class="testimonial-slider__container" slides-per-view="2"
                            [autoplay]="{ delay: 3000 }" [pagination]="{ clickable: true }"
                            [loop]="true" [spaceBetween]="30" [breakpoints]=" breakpoints"
                            style="width: 100%;height: auto;">
                            <swiper-slide *ngFor="let testimonialChunk of testimonialChunks"
                                class="brand-logo brand-logo--slider">
                                <div class="testimonial-slider__one wow move-up pb-5">
                                    <div class="row">
                                        <div class="col-md-12" *ngFor="let testimonial of testimonialChunk">
                                            <div class="testimonial-slider--info d-flex">

                                                <div class="testimonial-slider__author">
                                                    <div class="testimonial-rating">
                                                        <i class="fa-solid fa-star"
                                                            *ngFor="let star of [1,2,3,4,5]"></i>
                                                    </div>
                                                    <div class="author-info">
                                                        <div class="name mat-h4 fw-bold">{{ testimonial.name }} 
                                                            <span
                                                                class="designation px-2 text-secondary" *ngIf="testimonial.designation">/ {{
                                                                testimonial.designation }}</span></div>
                                                    </div>
                                                </div>
                                                <div class="testimonial-slider__media">
                                                    <img *ngIf="testimonial.imageUrl" [src]="getImageUrl(testimonial.imageUrl)" 
                                                        style="height:120px; width:120px" [alt]=testimonial.name>
                                                </div>
                                            </div>
                                            <div class="global_section_content testimonial-slider__text">
                                                {{ testimonial.comment }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination"></div>
                        </swiper-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--============ What our Clients Say End ============-->
<!--============ What our Employees Say Start ============-->
<section class="employee-carosel">
    <div class="testimonial-slider-area pt-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-wrap text-center section-space--mb_40">
                        <div class="section-sub-title mat-h6 fw-bold mb-20">What Our Employees Say</div>
                    </div>
                    <div class="testimonial-slider">
                        <swiper-container #empSwiperContainer class="testimonial-slider__container" slides-per-view="2"
                            [autoplay]="{ delay: 3000 }" [pagination]="{  clickable: true }"
                            [loop]="true" [breakpoints]="swiperBreakpoints">
                            <swiper-slide class="  employee-slider">
                                <div class="recognition-employees   testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="testimonial-slider__media pt-3">
                                            <img src="../../../assets/images/recognition/placeholder.png"
                                                class="img-fluid" alt="recognition">
                                        </div>
                                        <div class="testimonial-slider__author">
                                            <div class="testimonial-rating">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <div class="author-info">
                                                <div class="name mat-h4 fw-bold">Meghanath Nagulapalli, Java Developer</div>
                                                <span class="designation"> Nexus AutoGlass CT</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        If a house has strong foundation and pillars, the house stands the test of time.
                                        My experience with Maganti IT Resources, LLC has been akin to that.
                                        I have been working with them since 2017. After my graduation, I was lucky
                                        enough to find an employer such as Maganti IT who guided me
                                        through each and every step to become a software professional. They are always
                                        there for me just like a family. I strongly recommend
                                        my employer as an option to those individuals who are looking for a right
                                        guidance to establish their career in their respective
                                        fields.</div>
                                </div>
                            </swiper-slide>
                            <swiper-slide class="  employee-slider">
                                <div class=" recognition-employees testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="testimonial-slider__media pt-3">
                                            <img src="../../../assets/images/recognition/placeholder.png"
                                                class="img-fluid" alt="recognition">
                                        </div>
                                        <div class="testimonial-slider__author">
                                            <div class="testimonial-rating">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <div class="author-info">
                                                <div class="name mat-h4 fw-bold">Kishore V, Project Manager</div>
                                                <span class="designation">Proprietor, CPA AuditPro 411</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        I worked for Maganti IT Resources, LLC for over for 6 years and so far, the
                                        experience had been nothing less than amazing.
                                        I can concentrate on the work and need not worry about anything- everything from
                                        visa filing- paycheck- support, everything
                                        found to be seamless. The Owner and the staff, especially HR were very
                                        professional and courteous in any matter I brought
                                        up with and tend to resolve quickly and amicably. I'd highly recommend MIT for
                                        any consultants that look for good employer
                                        for Visa jobs/ Green Card filing to any project delivery in a timely manner.
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide class="  employee-slider">
                                <div class="  recognition-employees testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="testimonial-slider__media pt-3">
                                            <img src="../../../assets/images/recognition/placeholder.png"
                                                class="img-fluid" alt="slider">
                                        </div>
                                        <div class="testimonial-slider__author">
                                            <div class="testimonial-rating">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <div class="author-info">
                                                <div class="name mat-h4 fw-bold">MILIND RAHATE Programmer Analyst</div>
                                                <span class="designation"> C&R Yard Pro</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        Maganti IT Resources, LLC is a great company to work. I worked with them for 4
                                        years and they always respect their employees and really care well.
                                        I have my I-140 approved from Maganti IT Resources, LLC. They have honest
                                        leader, excellent management, great co-workers and friendly
                                        work culture. I learned a lot and never had any issues when I was working with
                                        them. I will definitely recommend Maganti IT
                                        Resources, LLC.</div>
                                </div>
                            </swiper-slide>
                            <swiper-slide class="  employee-slider">
                                <div class="recognition-employees testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="testimonial-slider__media pt-3">
                                            <img src="../../../assets/images/recognition/placeholder.png"
                                                class="img-fluid" alt="slider">
                                        </div>
                                        <div class="testimonial-slider__author">
                                            <div class="testimonial-rating">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                            </div>
                                            <div class="author-info">
                                                <div class="name mat-h4 fw-bold">Agile Business Analyst</div>
                                                <span class="designation">WholePerson Therapeutics LLC</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        I started my career with Maganti IT Resources, LLC (“MIT”) back in 2010. MIT is
                                        one of the most employee friendly places to work for.
                                        The culture is pretty good. Their pay structure is well designed and offers
                                        better than others. I don't think I could have made the
                                        same $/hour with any other company that early in my career. MIT is very flexible
                                        in accommodating their employee needs. I still am
                                        in contact with most of the people in the office in CT and if I need any kind of
                                        assistance, they will surely help me in any way
                                        they can.</div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination"></div>
                        </swiper-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--============ What our Employees Say End ============-->